<template>
  <AddonCard
    icon="users"
    title="Guest portals"
    link="https://docs.mailslurp.com/guest-portals/"
    :data-change="changeIndex"
    subtitle="Create branded login experiences for clients"
    :data-has-ai-plans="hasGuestPlans ? '1' : '0'"
    addon-id="guest"
    :loading="loading"
    :data-has-button="hasSubscriptionAndNoAddon ? '1' : '0'"
    :data-bad-currency-or-schedule="!product ? '1' : '0'"
    :no-footer="!hasSubscriptionAndNoAddon"
  >
    <div class="text-center" v-if="product">
      <TablePrice
        v-if="product.perUnitCost"
        :symbol="selectedCurrencySymbol"
        :currency="selectedCurrency"
        :price="product.perUnitCost"
        :text="'per ' + product.batchSize + ' guest per month'"
      />
    </div>
    <AddonNotSupported v-else />
    <template #footer>
      <UpgradeButtonAddAddonPlan
        v-if="hasSubscriptionAndNoAddon"
        size="sm"
        expedite
        :addon="AppendProductAddonPlanAddonEnum.GUEST"
      />
    </template>
  </AddonCard>
</template>
<script setup lang="ts">
import {
  AppendProductAddonPlanAddonEnum,
  type StripeBatchedAddonPlanProduct,
} from '@mailslurp/admin-sdk';

import { onMounted, ref } from 'vue';
import { useStore3 } from '../../../store/main';
import { storeToRefs } from 'pinia';
import AddonCard from '../AddonCardSm.vue';
import TablePrice from '../../pricing/TablePrice.vue';
import { loadFetchMany } from '../../../lib/services/helpers';
import AddonNotSupported from '../AddonNotSupported.vue';
import UpgradeButtonAddAddonPlan from '../../../components/pricing/addon/UpgradeButtonAddAddonPlan.vue';

const store3 = useStore3();

const loading = ref<boolean>(false);

defineProps<{
  changeIndex: number;
}>();

const {
  productGuestPlans,
  selectedSchedule,
  selectedCurrency,
  selectedCurrencySymbol,
  subscription,
  guestPlans,
} = storeToRefs(store3);
const product = computed(() => {
  return (productGuestPlans.value?.products ?? []).filter(
    (it: StripeBatchedAddonPlanProduct) =>
      it.schedule?.toString() === selectedSchedule.value?.toString() &&
      it.currency?.toString() === selectedCurrency.value?.toString(),
  )?.[0];
});
const hasGuestPlans = computed(() => {
  return (guestPlans.value?.length ?? 0) > 0;
});
const hasSubscriptionAndNoAddon = computed(() => {
  return subscription.value && !hasGuestPlans.value;
});

onMounted(async () => {
  await loadFetchMany(
    [() => store3.getProductGuestPlans(), () => store3.getGuestPlans()],
    store3,
    loading,
  );
});
</script>
